export const ASSETS = {
  tarotBack: "https://customer-assets.emergentagent.com/job_077fdd94-38c7-4c82-a06f-dcc5db77215c/artifacts/8wftwcxe_The%20back%20of%20a%20tarot%20card%2C%20with%20white%20boarders%2C%20a%20rainbow%20toroidal%20field%20on%20a%20indigo%20star%20cosmic%20back%20ground.jpg",
  tarotHorizontal: "https://customer-assets.emergentagent.com/job_077fdd94-38c7-4c82-a06f-dcc5db77215c/artifacts/iyfxrlyo_Tarot%20Cards%20-%201.png",
  vernaDesk: "https://customer-assets.emergentagent.com/job_077fdd94-38c7-4c82-a06f-dcc5db77215c/artifacts/w6dk05d1_IMG20221107112501.jpg",
  vernaMarket: "https://customer-assets.emergentagent.com/job_077fdd94-38c7-4c82-a06f-dcc5db77215c/artifacts/uv0b8kgz_Verna%20at%20market.jpg",
  tarotLayout: "https://customer-assets.emergentagent.com/job_077fdd94-38c7-4c82-a06f-dcc5db77215c/artifacts/w00a5nkf_OIP.Cl7Jdl8UpSoe7srbjcAawwHaE8.jpg",
  riderWaitePack: "https://customer-assets.emergentagent.com/job_verna-tarot-readings/artifacts/c4hh9blb_IMG_20230806_085629.jpg",
  cosmicAbout: "https://customer-assets.emergentagent.com/job_verna-tarot-readings/artifacts/lnat1pg3_images-3.jpg",
  vernaHealing: "https://customer-assets.emergentagent.com/job_verna-tarot-readings/artifacts/u7uzk58y_IMGP7250.webp",
};

export const CONTACT_INFO = {
  phone: "027 320 0079",
  phoneHref: "tel:+64273200079",
  email: "vernajcarr@gmail.com",
  emailHref: "mailto:vernajcarr@gmail.com",
  location: "15 Mill Rd, Whitianga, New Zealand",
  address: "15 Mill Rd, Whitianga",
  mapEmbed: "https://www.google.com/maps?q=15+Mill+Rd,+Whitianga,+New+Zealand&hl=en&z=15&output=embed",
};

export const PRICING = [
  { id: "thirty", duration: "30 minutes", price: "$NZ 60", desc: "An extended look at the energies around you and the path ahead.", popular: false },
  { id: "hour",   duration: "1 hour",     price: "$NZ 120", desc: "A deep, soul-level reading covering multiple themes of your life.", popular: true },
];

export const TESTIMONIALS = [
  {
    quote: "Hey Verna, thanks for spending time with mum Joy this afternoon — it's just what she needed and it sounds like you blew her mind with your amazing reading and gifts.",
    author: "Racheal",
  },
  {
    quote: "I didn't know what to expect, but your advice was real and grounded. It helped me make a decision I had been avoiding for months. Thanks Verna, really appreciate your help.",
    author: "Steve — Tauranga",
  },
  {
    quote: "I had a reading with you at the market. You are certainly perceptive and spot-on. I told my sister to give you a ring.",
    author: "Maggie",
  },
];

export const NAV_SECTIONS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "tarot", label: "Tarot" },
  { id: "deck", label: "The Deck" },
  { id: "spreads", label: "Spreads" },
  { id: "testimonials", label: "Testimonials" },
  { id: "contact", label: "Contact" },
  { id: "healing", label: "Healing" },
];

export const BRAND_TAGLINE = "The cards are a bridge — connecting me with you and the Infinite Wisdom of the Universe.";
